<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" :title="title" centered destroyOnClose width="70%">
    <a-space>
      <vxe-input v-model="query['no']" clearable placeholder="business.label.no" size="small" type="search" @search-click="search"/>
      <vxe-input v-model="query['name']" clearable placeholder="business.label.name" size="small" type="search" @search-click="search"/>
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      :height="height"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50"/>
      <vxe-column field="no" title="business.label.no"/>
      <vxe-column field="name" title="business.label.name"/>
      <vxe-column field="codeInitial" title="business.label.codeInitial"/>
      <vxe-column field="codeLength" title="business.label.codeLength"/>
      <vxe-column field="dimension.length" title="business.label.length"/>
      <vxe-column field="dimension.width" title="business.label.width"/>
      <vxe-column field="dimension.height" title="business.label.height"/>
      <vxe-column field="dimension.volume" title="business.label.volume"/>
      <vxe-column field="weight" title="business.label.weight"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="physical" title="business.label.physical" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="goback" title="business.label.goback" width="70"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="sendingErp" title="business.label.sendingErp" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import { findAll } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ContainerTypeModal',
  data() {
    return {
      show: true,
      page: 1,
      size: 15,
      contentSize: 0,
      visible: false,
      loading: false,
      data: [],
      query: { no: '', name: '' },
      args: {},
      selectedRowKeys: [],
      selectedRows: [],
      record: undefined,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.65)
    }
  },
  props: {
    selectType: {
      type: String,
      default: 'radio'
    },
    title: {
      type: String,
      default: '容器类型检索'
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    init(args) {
      this.query = { no: '', name: '' }
      this.data = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e) {
      this.init(args)
      this.record = e
      this.visible = true
      this.loading = true
      setTimeout(() => {
        this.getData()
      }, 300)
    },
    getData() {
      this.loading = true
      findAll('containerTypeFactory', this.query, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        let radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        selectedRows = this.$refs.table.getCheckboxRecords()
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>